'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

var _ChatHeadingConfigPropType = require('ui-addon-conversations/chat-heading-config/prop-types/ChatHeadingConfigPropType');

var _ChatHeadingConfigPropType2 = _interopRequireDefault(_ChatHeadingConfigPropType);

var _RecordPropType = require('conversations-prop-types/prop-types/RecordPropType');

var _RecordPropType2 = _interopRequireDefault(_RecordPropType);

var _color = require('../visitor-widget/util/color');

var _WidgetHeaderButton = require('./WidgetHeaderButton');

var _WidgetHeaderButton2 = _interopRequireDefault(_WidgetHeaderButton);

var _ThreadListHeader = require('./components/ThreadListHeader');

var _ThreadListHeader2 = _interopRequireDefault(_ThreadListHeader);

var _WidgetHeaderAvatarWrapper = require('./components/WidgetHeaderAvatarWrapper');

var _WidgetHeaderAvatarWrapper2 = _interopRequireDefault(_WidgetHeaderAvatarWrapper);

var _ShowThreadListButton = require('./components/ShowThreadListButton');

var _ShowThreadListButton2 = _interopRequireDefault(_ShowThreadListButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HEADER_BUTTON_STYLE = { width: 24, fontSize: 20 };
var THREAD_LIST_HEADER_PADDING_TOP = 'p-top-11';

var WidgetHeader = _react2.default.createClass({
  displayName: 'WidgetHeader',

  propTypes: {
    availabilityMessage: _react.PropTypes.string,
    chatHeadingConfig: _ChatHeadingConfigPropType2.default.isRequired,
    chatHeadingResponders: _react.PropTypes.instanceOf(_immutable.List).isRequired,
    coloring: (0, _RecordPropType2.default)('ColoringRecord').isRequired,
    createNewThread: _react.PropTypes.func.isRequired,
    inline: _react.PropTypes.bool.isRequired,
    mobile: _react.PropTypes.bool,
    onClose: _react.PropTypes.func.isRequired,
    preview: _react.PropTypes.bool,
    previewResponseTimeText: _react.PropTypes.string,
    showAvailabilityMessage: _react.PropTypes.bool.isRequired,
    showStatusIndicator: _react.PropTypes.bool.isRequired,
    showThreadList: _react.PropTypes.func.isRequired,
    showThreadListButton: _react.PropTypes.bool.isRequired,
    unseenThreadsCountExcludingCurrentThread: _react.PropTypes.number.isRequired,
    viewingThreadList: _react.PropTypes.bool
  },

  showNewThreadButton: function showNewThreadButton() {
    return !!this.props.viewingThreadList;
  },
  getHeaderClassName: function getHeaderClassName() {
    var mobile = this.props.mobile;


    return (0, _classNames2.default)('widget-header p-x-4', {
      mobile: mobile
    });
  },
  getHeaderBottomPaddingClassName: function getHeaderBottomPaddingClassName() {
    var _props = this.props,
        showAvailabilityMessage = _props.showAvailabilityMessage,
        showThreadListButton = _props.showThreadListButton,
        mobile = _props.mobile;


    if (showAvailabilityMessage && showThreadListButton) {
      return mobile ? 'p-bottom-5' : 'p-bottom-8';
    } else if (showThreadListButton || this.showNewThreadButton()) {
      return mobile ? 'p-bottom-2' : 'p-bottom-4';
    } else if (showAvailabilityMessage) {
      return 'p-bottom-12';
    }

    return mobile ? 'p-bottom-7' : 'p-bottom-10';
  },
  getHeaderTopPaddingClassName: function getHeaderTopPaddingClassName() {
    var mobile = this.props.mobile;

    if (mobile) {
      return 'p-top-5';
    }

    return '';
  },
  renderShowThreadsButton: function renderShowThreadsButton() {
    var _props2 = this.props,
        showThreadListButton = _props2.showThreadListButton,
        unseenThreadsCountExcludingCurrentThread = _props2.unseenThreadsCountExcludingCurrentThread,
        showThreadList = _props2.showThreadList;


    if (!showThreadListButton) {
      return _react2.default.createElement('div', { className: 'p-top-12', style: HEADER_BUTTON_STYLE });
    }

    return _react2.default.createElement(_ShowThreadListButton2.default, {
      unseenThreadsCountExcludingCurrentThread: unseenThreadsCountExcludingCurrentThread,
      showThreadList: showThreadList,
      style: HEADER_BUTTON_STYLE
    });
  },
  renderNewThreadButton: function renderNewThreadButton() {
    if (!this.showNewThreadButton()) {
      return _react2.default.createElement('div', { style: HEADER_BUTTON_STYLE });
    }

    return _react2.default.createElement(_WidgetHeaderButton2.default, {
      className: (0, _classNames2.default)('selenium-test-marker-new-thread-button', THREAD_LIST_HEADER_PADDING_TOP),
      style: HEADER_BUTTON_STYLE,
      iconName: 'description',
      onClick: this.props.createNewThread
    });
  },
  renderCloseButton: function renderCloseButton() {
    var _props3 = this.props,
        mobile = _props3.mobile,
        inline = _props3.inline,
        onClose = _props3.onClose;


    var shouldShowCloseButton = mobile && !inline;

    return shouldShowCloseButton && _react2.default.createElement(_WidgetHeaderButton2.default, {
      className: 'widget-close-button',
      iconName: 'remove',
      onClick: onClose
    });
  },
  render: function render() {
    var _props$coloring = this.props.coloring,
        accentColor = _props$coloring.accentColor,
        textColor = _props$coloring.textColor;
    var _props4 = this.props,
        availabilityMessage = _props4.availabilityMessage,
        chatHeadingConfig = _props4.chatHeadingConfig,
        chatHeadingResponders = _props4.chatHeadingResponders,
        mobile = _props4.mobile,
        showAvailabilityMessage = _props4.showAvailabilityMessage,
        showStatusIndicator = _props4.showStatusIndicator,
        viewingThreadList = _props4.viewingThreadList;


    return _react2.default.createElement(
      'div',
      (0, _color.getBrandClassNameAndStyle)(accentColor, 'background-panel-content'),
      _react2.default.createElement(
        'div',
        { className: this.getHeaderClassName(), style: { color: textColor } },
        _react2.default.createElement(
          'div',
          {
            className: (0, _classNames2.default)('justify-between', this.getHeaderBottomPaddingClassName(), this.getHeaderTopPaddingClassName(), { 'align-center': this.props.mobile })
          },
          this.renderShowThreadsButton(),
          viewingThreadList ? _react2.default.createElement(_ThreadListHeader2.default, null) : _react2.default.createElement(_WidgetHeaderAvatarWrapper2.default, {
            availabilityMessage: availabilityMessage,
            chatHeadingConfig: chatHeadingConfig,
            chatHeadingResponders: chatHeadingResponders,
            mobile: mobile,
            showAvailabilityMessage: showAvailabilityMessage,
            showStatusIndicator: showStatusIndicator
          }),
          this.renderNewThreadButton()
        ),
        _react2.default.createElement(
          'div',
          { className: 'widget-close-button-wrapper' },
          this.renderCloseButton()
        )
      )
    );
  }
});

exports.default = WidgetHeader;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-internal-components/static-1.4266/js/visitor-widget/WidgetHeader.js
// module id = 1047
// module chunks = 2 3